import ExpressAvailableTimeSlots from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import React from "react";

interface IExpressBookingScheduleContainer{
  isRescheduleModal?: boolean;
}

const ExpressBookingScheduleContainer = ({ isRescheduleModal = false }: IExpressBookingScheduleContainer) => {
  return (
    <>
      <div className="w-full h-full flex flex-col justify-between ">
        <div className="flex-grow w-full flex px-2">
          <ExpressAvailableTimeSlots
            title="Available times"
            isCarousal={false}
            isRescheduleModal={isRescheduleModal}
          />
        </div>
      </div>
    </>
  );
};

export default ExpressBookingScheduleContainer;
